// extracted by mini-css-extract-plugin
export default {"separator":"_2S8rp","postExcerpt":"_2yBgK","postTitle":"_1O3LV"};